import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./index.css";
import {
  Login,
  Dashboard,
  DashboardByUser,
  Pegawai,
  Lead,
  PcpList,
  PcpApprove,
  PcpPenjualan,
  PcpPenjualanEdit,
  PcpSewa,
  PcpSewaEdit,
  Sales,
  SalesLead,
  Sph,
  NotFound,
  Customer,
  PcpDetail,
  DashboardSpv,
} from "./pages";
import { PrivateRouteComp } from "./auth";

function App() {
  useEffect(() => {
    console.log("REAL MOUNT App");
    return () => console.log("REAL UNMOUNT App");
  }, []);
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route
          path="/dashboard"
          element={
            <PrivateRouteComp>
              <Dashboard />
            </PrivateRouteComp>
          }
        />
        <Route
          path="/dashboard-sales/:id"
          element={
            <PrivateRouteComp>
              <DashboardByUser />
            </PrivateRouteComp>
          }
        />
        <Route
          path="/dashboard-spv"
          element={
            <PrivateRouteComp>
              <DashboardSpv />
            </PrivateRouteComp>
          }
        />
        <Route
          path="/pegawai"
          element={
            <PrivateRouteComp>
              <Pegawai />
            </PrivateRouteComp>
          }
        />
        <Route
          path="/lead"
          element={
            <PrivateRouteComp>
              <Lead />
            </PrivateRouteComp>
          }
        />
        <Route
          path="/pcp"
          element={
            <PrivateRouteComp>
              <PcpList />
            </PrivateRouteComp>
          }
        />
        <Route
          path="/pcp-approve/:id"
          element={
            <PrivateRouteComp>
              <PcpApprove />
            </PrivateRouteComp>
          }
        />
        <Route
          path="/pcp-detail/:id"
          element={
            <PrivateRouteComp>
              <PcpDetail />
            </PrivateRouteComp>
          }
        />
        <Route
          path="/pcp-penjualan"
          element={
            <PrivateRouteComp>
              <PcpPenjualan />
            </PrivateRouteComp>
          }
        />
        <Route
          path="/pcp-penjualan/:id"
          element={
            <PrivateRouteComp>
              <PcpPenjualanEdit />
            </PrivateRouteComp>
          }
        />
        <Route
          path="/pcp-sewa"
          element={
            <PrivateRouteComp>
              <PcpSewa />
            </PrivateRouteComp>
          }
        />
        <Route
          path="/pcp-sewa/:id"
          element={
            <PrivateRouteComp>
              <PcpSewaEdit />
            </PrivateRouteComp>
          }
        />
        <Route
          path="/sales"
          element={
            <PrivateRouteComp>
              <Sales />
            </PrivateRouteComp>
          }
        />
        <Route
          path="/customer"
          element={
            <PrivateRouteComp>
              <Customer />
            </PrivateRouteComp>
          }
        />
        <Route
          path="/sales-lead"
          element={
            <PrivateRouteComp>
              <SalesLead />
            </PrivateRouteComp>
          }
        />
        <Route
          path="/sph"
          element={
            <PrivateRouteComp>
              <Sph />
            </PrivateRouteComp>
          }
        />

        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
